import store from "@/store/index";

/**
 * shutterstock 对外宣传的起步价。
 *
 * <p>2026-08-22 00:00 起，经 signUpV2 注册的新用户 shutterstock 单价是 1 元；
 * 在那之前注册的老用户仍然是 1.9 元。价格是注册时一次性写死在 fly_account_info 上的
 * （SHUTTERSTOCK_PRICE / SHUTTERSTOCK_PRICEV3 两列），老用户的行不会被改动。
 *
 * <p>所以对外只能说"1 元起"——不能直接说"1 元"，否则对老用户是错的。
 */
export const SS_START_PRICE = 1;

/**
 * 取当前登录用户真实的 shutterstock 单价。
 *
 * @param {string} field 账号上的价格字段：默认渠道(V3)用 shutterstockPriceV3，
 *                       SS/Hai 渠道用 shutterstockPrice
 * @returns {number|null} 拿不到就返回 null（未登录、userInfo 还没回来、字段为空）
 */
export function userShutterstockPrice(field = "shutterstockPriceV3") {
  try {
    const common = store && store.state ? store.state.common : null;
    const info = common ? common.userInfo : null;
    if (!info) {
      return null;
    }
    const raw = info[field];
    if (raw === null || raw === undefined || raw === "") {
      return null;
    }
    const n = Number(raw);
    //后端偶尔会把没配的价格给成 0，那不是"免费"而是"没取到"，按拿不到处理
    return !isNaN(n) && n > 0 ? n : null;
  } catch (e) {
    return null;
  }
}

/**
 * 渠道卡片上要显示的 shutterstock 价格。
 *
 * <p>登录用户显示他自己的真实单价（老用户 1.9、新用户 1），未登录显示对外起步价。
 * 这样"全站宣传 1 元起"和"老用户看到的仍是 1.9"这两件事同时成立，
 * 也不会出现"页面写 1 元、实际扣 1.9"的投诉。
 *
 * @returns {{price:number, isStart:boolean}} isStart 为 true 表示这是起步价而非用户真实价，
 *          用来决定文案是"1元起"还是"1.9元/张"
 */
export function shutterstockDisplayPrice(field = "shutterstockPriceV3") {
  const real = userShutterstockPrice(field);
  if (real === null) {
    return { price: SS_START_PRICE, isStart: true };
  }
  return { price: real, isStart: false };
}
